// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__go5R4","label":"SetPasswdForm_label__2nFm0"};